export default __webpack_public_path__ + "static/media/city-top-view.2617cd75.jpg";